// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

// CORR-02: absent values must be null, never NaN/Infinity/fabricated 0 — this
// is the single type-guard all dashboard selector modules narrow through
// (budget-gauge, time-metrics, spend-breakdown, evaluation-protocol,
// cycle-config, forge-record).
export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value)
